import { Components, Theme } from '@mui/material';

export default function OutlinedInput({ palette }: Theme): Components {
  return {
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          '&:focus': {
            borderWidth: '1px',
            borderColor: palette.secondary.main,
          },
        },
      },
    },
  };
}
